module.exports = __webpack_public_path__ + "img/88.7a7f6ca2.jpg";